export enum PaymentResponse {
  SUCCESS = 'success',
  FAILED = 'failed',
  SUBMITTED = 'submitted',
  INVALID = 'invalid',
  INIT = 'init',
}
